import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  { q: "How do counselling sessions work?", a: "Sessions are 45–50 minute one-on-one conversations held online via a secure audio or video call. We'll start with what brought you here, explore patterns, and work towards practical, sustainable steps. There's no pressure to share more than you're ready for." },
  { q: "Are online sessions available?", a: "Yes — all sessions are currently conducted online via a secure audio or video call, so you can connect from wherever feels safe and comfortable to you. In-person sessions are not offered at this time." },
  { q: "How can I book a consultation?", a: "Visit the 'Book a Consultation' page, fill in the form, and I'll confirm your appointment via email within 24-48 hours. You can also reach me via WhatsApp or email directly." },
  { q: "Is my information kept confidential?", a: "Absolutely. Everything shared in sessions is held in strict confidence, in line with professional ethics. The only exceptions are situations where there's a serious risk of harm — and these will be discussed transparently with you." },
  { q: "What can I expect during the first session?", a: "The first session is gentle and exploratory. We'll talk about what's been on your mind, your hopes for therapy, and what kind of support feels right. There are no scripts — just an honest conversation." },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page">
      <section className="container-soft pt-16 md:pt-24 pb-10">
        <div className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--primary-deep)" }}>FAQ</div>
        <h1 className="font-display text-5xl sm:text-6xl mb-6 max-w-3xl" style={{ color: "var(--text-primary)" }}>Common questions, gently answered</h1>
      </section>

      <section className="container-soft pb-24 max-w-3xl">
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="rounded-2xl overflow-hidden" style={{ background: "var(--surface)", border: "1px solid var(--border-soft)" }} data-testid={`faq-${i}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-6 text-left">
                  <span className="font-display text-xl" style={{ color: "var(--text-primary)" }}>{f.q}</span>
                  {isOpen ? <Minus size={18}/> : <Plus size={18}/>}
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 text-[15px] leading-relaxed" style={{ color: "var(--text-secondary)" }}>{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
